const eeElement = document.querySelector('.easterEgg');
const eePlaceholder = document.createElement('div');
const easterEggShadow = document.querySelector('#iconShadow');
const eeShadowPath = document.querySelector('#iconShadow path');
const eeIconWithBackground = document.querySelector('.iconWithBackground');
const eePosition = { x: 0, y: 0 };
const eeVerticalAcceleration = 1;
let eeIconClickCount = 0;
let eeStartEasterEgg = false;
let eeElementHeight = 0;
let eeElementWidth = 0;
let eeYVelocity = 0;
let eeXVelocity = 0;
let eeScale = 1;
let eeRotation = 0;

function eeOffset(el) {
	const rect = el.getBoundingClientRect();
	const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}
eeElement.addEventListener('click', () => {
	eeIconClickCount += 1;
	if (eeIconClickCount >= 10 && eeIconClickCount < 15) {
		const clickDirection = Math.random() < 0.5 ? -1 : 1;
		eeIconWithBackground.style.transform = `rotate(${((eeIconClickCount - 9) / 15) * 60 * clickDirection}deg)`;
		return;
	}
	if (eeIconClickCount > 15 && eeXVelocity < 1 && eeYVelocity < 1) {
		eeXVelocity += (Math.random() - 0.5) * 20;
		eeYVelocity -= 20;
		return;
	}
	if (eeIconClickCount === 15) {
		eeXVelocity = 10 * Math.random();
		eeYVelocity = 10 * Math.random();
		eeElementHeight = parseInt(window.getComputedStyle(eeElement.parentNode).getPropertyValue('height'), 10);
		eeElementWidth = parseInt(window.getComputedStyle(eeElement.parentNode).getPropertyValue('width'), 10);
		eePosition.x = -(eeElementWidth / 2);
		eePlaceholder.innerHTML = '[cool big icon]';
		eePlaceholder.style.height = `${eeElementHeight}px`;
		eeElement.parentNode.insertBefore(eePlaceholder, eeElement);
		eeElement.style.top = `${eePosition.y}px`;
		eeElement.style.left = `${eePosition.x}px`;
		eeElement.style.position = 'absolute';
		eeElement.style.zIndex = 1;
		eeScale = eeElementWidth / 111;
		eeShadowPath.style.fill = '#aaa';
		eeStartEasterEgg = true;
	}
});
function step() {
	if (eeStartEasterEgg) {
		eeYVelocity += eeVerticalAcceleration;

		if (eeOffset(eeElement).left + eeXVelocity < 0) {
			eeXVelocity = -eeXVelocity;
			eePosition.x -= eeOffset(eeElement).left + eeXVelocity;
		} else if (eeOffset(eeElement).left + eeElementWidth + eeXVelocity > window.innerWidth) {
			eeXVelocity = -eeXVelocity;
			eePosition.x -= eeOffset(eeElement).left + eeElementWidth + eeXVelocity - window.innerWidth;
		}
		eePosition.x += eeXVelocity;

		if (eeOffset(eeElement).top + eeElementHeight + eeYVelocity > window.innerHeight) {
			eePosition.y -= eeOffset(eeElement).top + eeElementHeight + eeYVelocity - window.innerHeight;
			eePosition.y += eeYVelocity;
			eeElement.style.top = `${eePosition.y}px`;
			eeYVelocity *= -0.5;
			eeXVelocity *= 0.95;
			if (Math.abs(eeYVelocity) < 0.1 && Math.abs(eeXVelocity) < 0.1) {
				return;
			}
		} else {
			eePosition.y += eeYVelocity;
		}
		eeElement.style.top = `${eePosition.y}px`;
		eeElement.style.left = `${eePosition.x}px`;
		eeRotation += eeXVelocity;
		eeIconWithBackground.style.transform = `rotate(${eeRotation}deg)`;
		const distanceFromBottom = (window.innerHeight - eeOffset(eeElement).top) / eeScale;
		eeElement.style.height = `${distanceFromBottom}px`;
		let shadowSize = distanceFromBottom - eeElementHeight - 300;
		shadowSize = shadowSize < 0 ? Math.max(0.2, Math.abs(shadowSize) / 300) : 0.2;
		easterEggShadow.style.transform = `translate(10px, ${distanceFromBottom - 29}px) scale(${shadowSize})`;
	}
	window.requestAnimationFrame(step);
}

window.requestAnimationFrame(step);
